<template>
  <OptionSelectBase :is-multi-select="false" v-model:fields="fields" @on-click="emit('onClick')" />
</template>

<script setup lang="ts">
import OptionSelectBase from '../OptionSelectBase/OptionSelectBase.vue'
import { type OptionSelectFields, getDefaultOptionSelectFields } from '../OptionSelectBase/types'

const fields = defineModel<OptionSelectFields>('fields', {
  required: true,
  default: () => getDefaultOptionSelectFields({ showIndicator: false }),
})

const emit = defineEmits<{
  (e: 'onClick'): void
}>()
</script>
